import React from "react";
import ReactApexChart from "react-apexcharts";
import useWindowDimensions from "../../utils/useWindowDimensions";
import { platformName } from "../../utils/useWindowDimensions";

const PlatformVisit = ({ platform }) => {
  let { width } = useWindowDimensions();

  const chartData = {
    series: [
      {
        name: "Count",
        data: platform.map((e) => e.count),
      },
    ],
    options: {
      chart: {
        type: "radar",
        toolbar: {
          show: false,
        },
      },
      dataLabels: {
        enabled: false,
      },
      plotOptions: {
        radar: {
          offsetY: 20,
          size: width > 1400 && width < 1700 ? 75 : width >= 1700 ? 85 : 65,
          polygons: {
            fill: {
              colors: ["#f8f8f8"],
            },
          },
          curve: "smooth",
        },
      },
      colors: ["#CA353B"],
      fill: "solid",
      tooltip: {
        y: {
          formatter: function (val) {
            return val;
          },
        },
      },
      xaxis: {
        categories: platform.map((e) => platformName[e.platform]),
        labels: {
          style: {
            colors: ["#333", "#333", "#333", "#333", "#333"],
            fontSize: width > 1400 && width < 1700 ? "11px" : width >= 1700 ? "13px" : "9px",
            fontFamily: "Poppins, sans-serif",
            fontWeight: "500",
          },
        },
      },
      yaxis: {
        show: false,
        tickAmount: 5,
      },
    },
  };

  return (
    <div id="chart">
      <ReactApexChart
        options={chartData.options}
        series={chartData.series}
        type="radar"
        height={width > 1400 && width < 1700 ? 235 : width >= 1700 ? 280 : 185}
      />
    </div>
  );
};

export default PlatformVisit;
